<template>
  <div class="section mb-4">
    <div class="section-header mb-2">
      <div>
        <h6 class="mb-0">LPNs pendientes de guardado</h6>
        <p class="text-caption text-grey mb-0">LPNs recibidos aún no almacenados en ubicación</p>
      </div>
      <span v-if="lpns.length > 0" class="badge-criticas">{{ lpns.length }} pendientes</span>
    </div>

    <v-skeleton-loader v-if="loading" type="table-row@4"></v-skeleton-loader>

    <template v-else>
      <v-text-field
        v-model="search"
        append-inner-icon="mdi-magnify"
        label="Buscar LPN, ASN, cliente, ubicación..."
        single-line
        hide-details
        density="compact"
        class="mb-2"
        style="max-width: 360px"
      ></v-text-field>

      <v-data-table
        :headers="headers"
        :items="lpns"
        :search="search"
        loading-text="Cargando..."
        no-data-text="Sin LPNs pendientes de guardado"
        density="compact"
      >
      <template v-slot:item="{ item }">
        <tr :class="{ 'row-stuck': isPendingLong(item) }">
          <td class="font-weight-medium">{{ item.lpn_code }}</td>
          <td>
            <span class="status-badge status-PEN">Recibido</span>
          </td>
          <td>ASN #{{ (item.asn_ids || []).join(', #') }}</td>
          <td>{{ item.client_username }}</td>
          <td>
            <span v-if="item.ubicacion_code">
              {{ item.ubicacion_code }}
              <span v-if="item.zona_name" class="table-text-secondary"> · {{ item.zona_name }}</span>
            </span>
            <span v-else class="text-grey">Sin ubicar</span>
          </td>
          <td>
            <span v-if="item.received_at" :class="{ 'text-danger font-weight-bold': isPendingLong(item) }">
              {{ formatElapsed(item.received_at) }}
            </span>
            <span v-else class="text-grey">-</span>
          </td>
        </tr>
      </template>
    </v-data-table>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    lpns:    { type: Array,   default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      search: '',
      headers: [
        { title: "LPN",              key: "lpn_code",        sortable: true  },
        { title: "Estado",           key: "state",           sortable: false },
        { title: "ASN",              key: "asn_ids",         sortable: false },
        { title: "Cliente",          key: "client_username", sortable: true  },
        { title: "Ubicación / Zona", key: "ubicacion_code",  sortable: false },
        { title: "Pendiente hace",   key: "received_at",     sortable: true  },
      ],
    };
  },
  methods: {
    elapsedHours(dateStr) {
      if (!dateStr) return 0;
      return (Date.now() - new Date(dateStr).getTime()) / 1000 / 3600;
    },
    isPendingLong(item) {
      return this.elapsedHours(item.received_at) > 4;
    },
    formatElapsed(dateStr) {
      const h = this.elapsedHours(dateStr);
      if (h < 1) return `hace ${Math.round(h * 60)} min`;
      if (h < 24) return `hace ${Math.floor(h)}h`;
      const days  = Math.floor(h / 24);
      const hours = Math.floor(h % 24);
      return `${days}d ${hours}h`;
    },
  },
};
</script>
